import { computed, Ref } from 'vue'

export default function usePaginatedData<T> (data: Ref<T[]>, pageSize: Ref<number>, currentPage: Ref<number>) {
    const totalPages = computed(() => Math.ceil(data.value.length / pageSize.value))

    const start = computed(() => {
        return (currentPage.value - 1) * pageSize.value
    })
    const end = computed(() => {
        return start.value + pageSize.value
    })

    const paginatedData = computed(() => {
        return data.value.slice(start.value, end.value)
    })
    return {
        totalPages,
        paginatedData,
        start,
        end
    }
}
